<template>
	<article v-if="data" class="podcast-content">
		<!-- 视频播放器 -->
		<figure class="podcast-content__video" v-if="data.media_url && isMp4Video(data.media_url)">
			<img src="../../../images/back.png" alt="" class="podcast-content__back" @click="goBack" />
			<video
				v-if="showVideoPlayer && playVideo(data.media_url)"
				ref="videoRef"
				controls
				width="100%"
				:src="getVideoUrl(data.media_url)"
				@click.stop
				autoplay
				@play="onVideoPlay"
				@timeupdate="onVideoTimeUpdate"
				:aria-label="t('square.detail.video.playAria', { title: data.title })"
			></video>
			<button
				v-else
				type="button"
				@click.prevent="onPlayPreviewClick"
				class="podcast-content__video-preview"
				:aria-label="t('square.detail.video.playAria', { title: data.title })"
			>
				<img
					:src="data.cover"
					:alt="t('square.detail.video.coverAlt', { title: data.title })"
					class="podcast-content__cover"
				/>
				<div class="podcast-content__mask" v-if="data.type == 1 && playVideo(data.media_url)"></div>
				<img
					:src="videoIcon"
					:alt="t('square.detail.video.playButtonAlt')"
					class="podcast-content__play-icon"
					v-if="data.type == 1 && playVideo(data.media_url)"
				/>
			</button>
		</figure>
		<figure
			class="podcast-content__video"
			v-else-if="data.media_url && isYoutubeUrl(data.media_url)"
		>
			<img src="../../../images/back.png" alt="" class="podcast-content__back" @click="goBack" />

			<div v-if="!showYoutubePlayer">
				<button
					type="button"
					@click.prevent="onYoutubePlayClick"
					class="podcast-content__video-preview"
					:aria-label="t('square.detail.video.youtubePlayAria', { title: data.title })"
				>
					<img
						:src="data.cover"
						:alt="t('square.detail.video.coverAlt', { title: data.title })"
						class="podcast-content__cover"
					/>
					<div class="podcast-content__mask" v-if="data.type == 1"></div>
					<img
						:src="videoIcon"
						:alt="t('square.detail.video.playButtonAlt')"
						class="podcast-content__play-icon"
						v-if="data.type == 1"
					/>
				</button>
			</div>
			<div v-else class="podcast-content__youtube">
				<iframe
					width="100%"
					height="422"
					:src="getYoutubeEmbedUrl(data.media_url)"
					frameborder="0"
					allow="
						accelerometer;
						autoplay;
						clipboard-write;
						encrypted-media;
						gyroscope;
						picture-in-picture;
					"
					allowfullscreen
					:title="t('square.detail.video.youtubeTitle', { title: data.title })"
				></iframe>
			</div>
		</figure>

		<div class="podcast-content__body">
			<div class="podcast-content__title">{{ data.title }}</div>

			<div class="podcast-content__meta">
				<img :src="videoIcon" alt="" class="podcast-content__meta-icon" />
				<span>{{ data.view_count || data.media_play_count || 0 }}</span>
				<span class="podcast-content__meta-divider">|</span>
				<span>{{ data.format_time }}</span>
			</div>

			<div class="podcast-content__author">
				<img
					:src="publisherInfo.avatar"
					:alt="publisherInfo.nickname"
					class="podcast-content__avatar"
				/>
				<span class="podcast-content__nickname">{{ publisherInfo.nickname }}</span>
				<button
					type="button"
					class="podcast-content__follow-btn"
					:class="{ 'podcast-content__follow-btn--followed': isFollowed }"
					@click="handleFollow"
				>
					{{ isFollowed ? t("square.detail.followed") : t("square.detail.follow") }}
				</button>
			</div>

			<div class="podcast-content__actions">
				<div
					type="button"
					class="podcast-content__action-btn"
					:disabled="squareZanLoading"
					@click="handleZan"
				>
					<img :src="isZaned ? zanAfterIcon : zanBeforeIcon" alt="" />
					<span>{{ t("square.detail.like") }}</span>
				</div>
				<div type="button" class="podcast-content__action-btn" @click="showSharePanel = true">
					<img :src="shareIcon" alt="" />
					<span>{{ t("square.detail.share") }}</span>
				</div>
			</div>

			<!-- 评论预览 -->
			<section class="podcast-content__comment-card" @click="openComments">
				<div class="podcast-content__comment-header">
					<span class="podcast-content__comment-title">
						{{ t("square.detail.comments") }}
						<span class="podcast-content__comment-count">{{ commentTotal }}</span>
					</span>
					<span class="podcast-content__comment-arrow" aria-hidden="true"></span>
				</div>
				<div v-if="firstComment" class="podcast-content__comment-preview">
					<img
						:src="firstComment.user_info?.avatar"
						:alt="firstComment.user_info?.nickname"
						class="podcast-content__comment-avatar"
					/>
					<p class="podcast-content__comment-text">{{ firstComment.reply }}</p>
				</div>
				<div class="podcast-content__comment-input" @click.stop="openComments">
					<img :src="writeIcon" alt="" class="icon1" aria-hidden="true" />
					<span>{{ t("square.detail.commentPlaceholder") }}</span>
					<img :src="submit1" alt="" class="icon2" />
				</div>
			</section>
		</div>

		<RecommendList :square-info="data" :square-id="squareId" />

		<CommentDrawer
			v-model:show="showCommentDrawer"
			v-model:comment-tab="commentTab"
			v-model:main-comment-text="mainCommentText"
			v-model:active-reply-draft="activeReplyDraft"
			:square-data="data"
			:comment-list="commentList"
			:comment-loading="commentLoading"
			:comment-total="commentTotal"
			:has-more-comments="hasMoreComments"
			:active-reply-id="activeReplyId"
			:comment-submitting="commentSubmitting"
			:reply-submitting="replySubmitting"
			:get-reply-state="getReplyState"
			:has-more-replies="hasMoreReplies"
			:toggle-view-replies="toggleViewReplies"
			:load-more-replies="loadMoreReplies"
			:load-more-comments="loadMoreComments"
			:toggle-reply-input="toggleReplyInput"
			:submit-main-comment="submitMainComment"
			:submit-reply-comment="submitReplyComment"
			:handle-comment-zan="handleCommentZan"
			:is-comment-zan-loading="isCommentZanLoading"
		/>

		<SharePanel v-model:show="showSharePanel" :share-list="shareList" @share="handleShare" />
	</article>
</template>

<script setup>
import { computed, inject, ref, watch } from "vue";
import { useI18n } from "~/composables/useI18n";
import { useSquare } from "~/composables/useSquare";
import { safeNavigateBack } from "~/utils/safeNavigateBack";
import CommentDrawer from "../comment-drawer/index.vue";
import RecommendList from "../recommend-list/index.vue";
import SharePanel from "../share-panel/index.vue";
import { usePlayProgressTracking } from "../../../composables/useSquareDetailTracking";
import videoIcon from "../../../images/vedio-xx.png";
import shareIcon from "../../../images/sahre.png";
import zanAfterIcon from "../../../images/zan-after.png";
import zanBeforeIcon from "../../../images/zan-before.png";
import writeIcon from "../../../images/write.svg";
import submit1 from "../../../images/submit2.png";

const props = defineProps({
	data: {
		type: Object,
		default: () => ({}),
	},
	squareId: {
		type: String,
		default: "",
	},
});

const { t } = useI18n();
const logDetailEvent = inject("logDetailEvent", null);

const commentTab = ref("hot");
const showCommentDrawer = ref(false);
const videoRef = ref(null);

const {
	trackPlayClick,
	handleTimeUpdate,
	markWatchStart,
	reset: resetPlayProgress,
} = usePlayProgressTracking(logDetailEvent, () => props.data);

watch(
	() => props.data?.id,
	() => resetPlayProgress()
);

const {
	isFollowed,
	isZaned,
	squareZanLoading,
	shareList,
	showSharePanel,
	handleFollow,
	handleZan,
	handleShare,
	commentList,
	commentLoading,
	commentTotal,
	hasMoreComments,
	mainCommentText,
	activeReplyId,
	activeReplyDraft,
	commentSubmitting,
	replySubmitting,
	getReplyState,
	hasMoreReplies,
	toggleViewReplies,
	loadMoreReplies,
	loadMoreComments,
	toggleReplyInput,
	submitMainComment,
	submitReplyComment,
	handleCommentZan,
	isCommentZanLoading,
} = useSquare(
	() => props.data,
	() => commentTab.value
);

const publisherInfo = computed(() => {
	return (
		props.data?.publisher_info || {
			nickname: "",
			avatar: "",
		}
	);
});

const firstComment = computed(() => commentList.value[0] || null);

const showVideoPlayer = ref(false);
const showYoutubePlayer = ref(false);

const onPlayPreviewClick = () => {
	trackPlayClick({ playPositionBucket: "main" });
	showVideoPlayer.value = true;
};

const onYoutubePlayClick = () => {
	trackPlayClick({ playPositionBucket: "main" });
	showYoutubePlayer.value = true;
};

const onVideoPlay = () => {
	markWatchStart();
};

const onVideoTimeUpdate = () => {
	handleTimeUpdate(videoRef.value);
};

const getVideoUrl = media_url => {
	if (!media_url) return "";
	if (Array.isArray(media_url) && media_url.length > 0) {
		return String(media_url[0]).replace(/\\\//g, "/");
	}
	if (typeof media_url !== "string") return "";
	let url = media_url;
	try {
		const parsed = JSON.parse(media_url);
		if (Array.isArray(parsed) && parsed.length > 0 && parsed[0]) {
			url = String(parsed[0]);
		}
	} catch {
		url = media_url.replace('["', "").replace('"]', "");
	}
	return url.replace(/\\\//g, "/");
};

const playVideo = media_url => getVideoUrl(media_url) !== "";

const openComments = () => {
	showCommentDrawer.value = true;
};

const goBack = () => {
	safeNavigateBack("/seer/square/podcast");
};

const isMp4Video = media_url => {
	const url = getVideoUrl(media_url);
	return url.toLowerCase().endsWith(".mp4");
};

const isYoutubeUrl = url => {
	const videoUrl = getVideoUrl(url);
	return videoUrl.includes("youtube.com") || videoUrl.includes("youtu.be");
};

const getYoutubeEmbedUrl = url => {
	const videoUrl = getVideoUrl(url);
	let videoId = "";
	if (videoUrl.includes("youtube.com/watch?v=")) {
		videoId = videoUrl.split("v=")[1];
		const ampersandPosition = videoId.indexOf("&");
		if (ampersandPosition !== -1) {
			videoId = videoId.substring(0, ampersandPosition);
		}
	} else if (videoUrl.includes("youtu.be/")) {
		videoId = videoUrl.split("youtu.be/")[1];
	}
	return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
};
</script>

<style lang="scss" scoped>
@mixin line-clamp($lines: 2) {
	display: -webkit-box;
	-webkit-line-clamp: $lines;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
}

.podcast-content {
	width: 750px;
	background: #ffffff;

	&__video {
		margin: 0;
		position: relative;
		width: 100%;
		line-height: 0;

		video {
			width: 100%;
			height: auto;
			display: block;
		}
	}

	&__back {
		position: absolute;
		top: 24px;
		left: 24px;
		z-index: 2;
		width: 64px;
		height: 64px;
	}

	&__video-preview {
		border: none;
		background: transparent;
		padding: 0;
		cursor: pointer;
		position: relative;
		display: block;
		width: 100%;

		.podcast-content__cover {
			width: 100%;
			height: 422px;
			display: block;
			object-fit: cover;
		}
	}

	&__play-icon {
		position: absolute;
		width: 80px;
		height: auto;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		pointer-events: none;
	}

	&__mask {
		position: absolute;
		inset: 0;
		background: rgba(0, 0, 0, 0.15);
		pointer-events: none;
	}

	&__youtube {
		position: relative;
		width: 100%;
		height: 422px;

		iframe {
			width: 100%;
			height: 100%;
		}
	}

	&__body {
		padding: 24px 30px 0;
	}

	&__title {
		margin: 0 0 16px;
		font-size: 32px;
		font-weight: 500;
		color: #333333;
		line-height: 1.5;
		@include line-clamp(3);
	}

	&__meta {
		display: flex;
		align-items: center;
		gap: 8px;
		margin-bottom: 24px;
		font-size: 24px;
		color: #595959;
	}

	&__meta-icon {
		width: 36px;
		height: 36px;
		object-fit: contain;
	}

	&__meta-divider {
		color: #cccccc;
	}

	&__author {
		display: flex;
		align-items: center;
		gap: 16px;
		margin-bottom: 24px;
		min-width: 0;
	}

	&__avatar {
		width: 64px;
		height: 64px;
		border-radius: 50%;
		object-fit: cover;
		flex-shrink: 0;
	}

	&__nickname {
		flex: 1;
		min-width: 0;
		font-size: 28px;
		font-weight: 500;
		color: #333333;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	&__follow-btn {
		flex-shrink: 0;
		padding: 10px 28px;
		border: none;
		border-radius: 8px;
		background: #f2af19;
		color: #ffffff;
		font-size: 26px;
		font-weight: 500;
		cursor: pointer;
		white-space: nowrap;

		&--followed {
			background: #f0f0f0;
			color: #999999;
		}
	}

	&__actions {
		display: flex;
		gap: 20px;
		margin-bottom: 24px;
	}

	&__action-btn {
		width: 136px;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 8px;
		border: none;
		border-radius: 8px;
		background: #f6f6f6;
		cursor: pointer;
		padding: 18px 0;

		&:disabled {
			cursor: not-allowed;
			opacity: 0.6;
		}

		img {
			width: 32px;
			height: 32px;
			object-fit: contain;
		}

		span {
			font-size: 24px;
			color: #333333;
			font-weight: 500;
		}
	}

	&__comment-card {
		border: 1px solid #efefef;
		border-radius: 16px;
		padding: 24px;
		margin-bottom: 32px;
		cursor: pointer;
	}

	&__comment-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 16px;
	}

	&__comment-title {
		font-size: 28px;
		font-weight: 500;
		color: #333333;
	}

	&__comment-count {
		margin-left: 8px;
		font-size: 24px;
		font-weight: 400;
		color: #595959;
	}

	&__comment-arrow {
		width: 16px;
		height: 16px;
		border-top: 2px solid #cccccc;
		border-right: 2px solid #cccccc;
		transform: rotate(45deg);
		flex-shrink: 0;
	}

	&__comment-preview {
		display: flex;
		align-items: flex-start;
		gap: 16px;
		margin-bottom: 16px;
	}

	&__comment-avatar {
		width: 56px;
		height: 56px;
		border-radius: 50%;
		object-fit: cover;
		flex-shrink: 0;
		background: #eeeeee;
	}

	&__comment-text {
		margin: 0;
		flex: 1;
		min-width: 0;
		font-size: 24px;
		color: #333333;
		line-height: 1.5;
		@include line-clamp(2);
	}

	&__comment-input {
		height: 80px;
		padding: 0 12px 0 24px;
		border-radius: 40px;
		background: #f5f5f5;
		display: flex;
		align-items: center;
		gap: 16px;
		box-sizing: border-box;

		.icon1 {
			flex-shrink: 0;
			width: 32px;
			height: 32px;
			object-fit: contain;
		}

		span {
			flex: 1;
			min-width: 0;
			font-size: 28px;
			color: #bbbbbb;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.icon2 {
			flex-shrink: 0;
			width: 64px;
			height: 64px;
			object-fit: contain;
		}
	}
}
</style>
